module.exports = __webpack_public_path__ + "static/media/rv_large.c1103c98.jpeg";